import * as React from "react";

;
export const PopoverOpen = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={17} fill="none" {...props}><rect width={16} height={16} y={0.5} fill="#3FD899" rx={4} /><path fill="#fff" d="M8 12.5 4.103 5.75h7.794L8 12.5Z" /></svg>;